/**
 * @generated SignedSource<<6b133834e3510a18e82f3c6a6d36ca0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type issuesDropdownNewsletterArticleArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "issuesDropdownNewsletterArticleArticle";
};
export type issuesDropdownNewsletterArticleArticle$key = {
  readonly " $data"?: issuesDropdownNewsletterArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"issuesDropdownNewsletterArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "issuesDropdownNewsletterArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "a9f704563422df6947cd811d1eb1b2b8";

export default node;
